var $67168d94a970eb34$exports = {};
$67168d94a970eb34$exports = {
    "info": `Tiedot`,
    "negative": `Virhe`,
    "positive": `Onnistui`
};


export {$67168d94a970eb34$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
